import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { get, map, sum, size, includes } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import ZoneColor from "../Common/ZoneColor";
import TableCellStyled from "../Common/TableCellStyled";

import { levels } from "../../constants/companies";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import { getAttributeValue } from "../../utils/profile";
import {
  calculateChildrenCount,
  displayBoolean,
  displayData,
} from "../../utils/data";
import EllipsedTextNew from "../Common/EllipsedTextNew";

const styles = {
  expandableItem: {
    cursor: "pointer",
  },
  textLink: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  link: {
    color: colors.primary,
    width: "40px",
    height: "40px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
  totalCount: {
    fontWeight: "bold",
    fontStyle: "italic",
    fontSize: "1.142em",
  },
  whiteBg: {
    backgroundColor: colors.white,
  },
  activeItem: {
    color: colors.black87,
    fontWeight: 500,
  },
  inactiveItem: {
    color: colors.black54,
    fontStyle: "italic",
  },
  arrowItem: {
    width: "12px",
    marginRight: "12px",
    cursor: "pointer",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: colors.lightGreenBg + " !important",
    },
  },
  dataCell: {
    color: colors.black54,
  },
  topBorder: {
    borderTop: `1px solid ${colors.veryLighPink}`,
  },
  leftBorder: {
    borderLeft: `1px solid ${colors.veryLighPink}`,
  },
  bottomBorder: {
    borderBottom: `1px solid ${colors.veryLighPink}`,
  },
  rightBorder: {
    borderRight: `1px solid ${colors.veryLighPink}`,
  },
  indented1: {
    paddingLeft: "50px !important",
  },
  indented2: {
    paddingLeft: "100px !important",
  },
  indented3: {
    paddingLeft: "150px !important",
  },
};

const CompaniesTableRow = withStyles(styles)((props) => {
  const {
    classes,
    index,
    level,
    levelId,
    item,
    fetchSites,
    fetchZones,
    fetchDevices,
    language,
    powerUserMode,
    expandedCompanies,
    expandedSites,
    expandedZones,
    onExpand,
  } = props;
  const [expandedDevice, setExpandedDevice] = React.useState(false);

  const expanded =
    level === levels.company
      ? includes(expandedCompanies, get(item, ["id"]))
      : level === levels.site
        ? includes(expandedSites, get(item, ["id"]))
        : level === levels.zone
          ? includes(expandedZones, get(item, ["id"]))
          : level === levels.device
            ? expandedDevice
            : false;

  let expandedRoot = props.expandedRoot;
  if (expandedRoot === undefined) {
    expandedRoot = expanded;
  }

  let isLast =
    props.isLast &&
    (!expanded ||
      size(
        get(item, [
          level === levels.company
            ? "sites"
            : level === levels.site
              ? "zones"
              : level === levels.zone
                ? "devices"
                : "external_devices",
        ])
      ) === 0);

  const borderBottomCondition =
    (levelId === 0 && !expanded) || isLast || (props.isGroupLast && !expanded);
  const borderTopCondition =
    expanded && levelId > 0 && level !== levels.childZone;

  const expandRow = (e) => {
    e.stopPropagation();

    if (level === levels.company) {
      onExpand("expandedCompanies", get(item, ["id"]));
      if (!includes(expandedCompanies, get(item, ["id"]))) {
        fetchSites(get(item, ["id"]));
      }
    } else if (level === levels.site) {
      onExpand("expandedSites", get(item, ["id"]));
      if (!includes(expandedSites, get(item, ["id"]))) {
        fetchZones(get(item, ["company_id"]), get(item, ["id"]));
      }
    } else if (level === levels.zone) {
      onExpand("expandedZones", get(item, ["id"]));
    } else if (level === levels.device) {
      setExpandedDevice(!expandedDevice);
    }
  };

  const goTo = (section) => {
    let url = "/admin/companies/";
    if (level === levels.company) {
      url += `${get(item, ["id"])}`;
    } else if (level === levels.site) {
      url += `${get(item, ["company_id"])}/sites/${get(item, ["id"])}`;
    } else if (includes([levels.zone, levels.childZone], level)) {
      url += `${get(item, ["company_id"])}/sites/${get(item, [
        "site_id",
      ])}/zones/${get(item, ["id"])}`;
    } else if (includes([levels.device, levels.externalDevice], level)) {
      url += `${get(item, ["company_id"])}/sites/${get(item, [
        "site_id",
      ])}/zones/${get(item, ["zone_id"])}/devices/${get(item, ["id"])}`;
    }
    if (section) url += `/${section}`;
    props.history.push(url);
  };

  const renderExpandableCell = (title, isZone = false, indentedClass) => {
    return (
      <TableCellStyled
        className={clsx(indentedClass, {
          [classes.bottomBorder]: borderBottomCondition && !isZone,
          [classes.topBorder]: borderTopCondition,
          [classes.leftBorder]:
            !isZone &&
            ((expanded && levelId > 0) ||
              (props.expandedParent &&
                levelId > 0 &&
                Boolean(get(item, ["parent_zone_id"])))),
        })}
      // style={{
      //   backgroundColor:
      //     index % 2 === 0 || (!isZone && levelId === 0)
      //       ? colors.white
      //       : colors.tableDarkBg,
      // }}
      >
        <Grid container alignItems="center" wrap="nowrap">
          {level !== "child" ?
            <Grid item className={classes.arrowItem} onClick={expandRow}>
              <img
                src={expanded ? images.arrowOpenBlack : images.arrowClosedBlack}
                height="10px"
                style={{ maxWidth: "10px" }}
                alt="arrow"
              />
            </Grid>
            : <></>}
          <Grid
            item
            className={clsx(classes.expandableItem, classes.textLink)}
            onClick={() => goTo("details")}
          >
            {title}
          </Grid>
        </Grid>
      </TableCellStyled>
    );
  };

  const renderCompanyRow = () => {
    return (
      <>
        {renderExpandableCell(
          `${get(item, ["name"])} (${get(item, ["site_count"])})`
        )}
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {get(item, [`company_type_name_${language}`])}
        </TableCellStyled>
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
          })}
        />
        <TableCellStyled
          className={clsx(classes.dataCell, classes.totalCount, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {get(item, ["zone_count"])}
        </TableCellStyled>
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          <span
            className={clsx(classes.link, classes.totalCount)}
            onClick={() => goTo("profiles")}
          >
            {get(item, ["profile_count"]) || 0}
          </span>
        </TableCellStyled>
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          <span
            className={clsx(classes.link, classes.totalCount)}
            onClick={() => goTo("devices")}
          >
            {get(item, ["device_count"])}
          </span>
        </TableCellStyled>
      </>
    );
  };

  const renderSiteRow = () => {
    return (
      <>
        {!get(props, ["hide", "company"]) && (
          <TableCellStyled
            className={clsx(classes.whiteBg, {
              [classes.bottomBorder]: borderBottomCondition,
            })}
            colSpan={2}
          />
        )}
        {renderExpandableCell(
          `${get(item, ["name"])} (${get(item, ["zone_count"])})`
        )}
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
            [classes.topBorder]: borderTopCondition,
          })}
        />
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
            [classes.topBorder]: borderTopCondition,
          })}
        >
          <span
            className={clsx(classes.link, classes.totalCount)}
            onClick={() => goTo("profiles")}
          >
            {get(item, ["profile_count"]) || 0}
          </span>
        </TableCellStyled>
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
            [classes.topBorder]: borderTopCondition,
            [classes.rightBorder]: expanded && levelId > 0,
          })}
        >
          <span
            className={clsx(classes.link, classes.totalCount)}
            onClick={() => goTo("devices")}
          >
            {get(item, ["device_count"])}
          </span>
        </TableCellStyled>
      </>
    );
  };

  const renderZoneRow = () => {
    const hasChilds = size(get(item, ["childs"])) > 0;
    return (
      <>
        {!get(props, ["hide", "company"]) && (
          <TableCellStyled
            className={clsx(classes.whiteBg, {
              [classes.bottomBorder]:
                borderBottomCondition && (!props.isGroupLast || isLast),
            })}
            colSpan={2}
          />
        )}
        {!get(props, ["hide", "site"]) && (
          <TableCellStyled
            className={clsx(classes.whiteBg, {
              [classes.bottomBorder]:
                borderBottomCondition && level !== levels.childZone,
              [classes.leftBorder]:
                props.expandedParent && !get(props, ["hide", "company"]),
            })}
          />
        )}
        {hasChilds ? (
          renderExpandableCell(
            `${get(item, ["name"])} (${calculateChildrenCount(
              item,
              "childs"
            )})`,
            false,
            Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 0
              ? classes.indented1
              : Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 1
                ? classes.indented2
                : null
          )
        ) : (
          <TableCellStyled
            className={clsx({
              [classes.indented1]:
                Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 0,
              [classes.indented2]:
                Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 1,
              [classes.indented3]:
                Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 2,
              [classes.bottomBorder]: borderBottomCondition,
              [classes.leftBorder]:
                props.expandedParent &&
                levelId > 0 &&
                Boolean(get(item, ["parent_zone_id"])),
            })}
          >
            <span className={classes.textLink} onClick={() => goTo("details")}>
              {get(item, ["name"])}
            </span>
          </TableCellStyled>
        )}
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
            [classes.topBorder]: borderTopCondition,
          })}
        >
          <span
            className={clsx(classes.link, {
              [classes.totalCount]: hasChilds,
            })}
            onClick={() => goTo("profiles")}
          >
            {get(item, ["profile_count"]) + get(item, ["profile_total"]) || 0}
          </span>
        </TableCellStyled>
        <TableCellStyled
          className={clsx({
            [classes.bottomBorder]: borderBottomCondition,
            [classes.topBorder]: borderTopCondition,
            [classes.rightBorder]:
              levelId > 0 && (props.expandedParent || expanded),
          })}
        >
          <span
            className={clsx(classes.link, {
              [classes.totalCount]: hasChilds,
            })}
            onClick={() => goTo("items")}
          >
            {get(item, ["device_count"]) + get(item, ["device_total"]) || 0}
          </span>
        </TableCellStyled>
      </>
    );
  };

  const renderZoneRowDetailed = () => {
    const zonesData = [
      get(item, [`zone_type_name_${language}`]),
      get(item, ["color", "code"]) || get(item, ["type", "color", "code"]),
      displayBoolean(get(item, ["is_entrance"]) || false),
      displayBoolean(get(item, ["is_exit"]) || false),
      displayData(getAttributeValue(item, 19)),
    ];

    const hasChilds = size(get(item, ["childs"])) > 0;

    return (
      <>
        {hasChilds ? (
          renderExpandableCell(
            `${get(item, ["name"])} (${calculateChildrenCount(
              item,
              "childs"
            )})`,
            true,
            Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 0
              ? classes.indented1
              : Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 1
                ? classes.indented2
                : null
          )
        ) : (
          <TableCellStyled
            className={clsx({
              [classes.indented1]:
                Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 0,
              [classes.indented2]:
                Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 1,
              [classes.indented3]:
                Boolean(get(item, ["parent_zone_id"])) && props.zoneLevel === 2,
            })}
          >
            <span className={classes.textLink} onClick={() => goTo("details")}>
              {get(item, ["name"])}
            </span>
          </TableCellStyled>
        )}
        <TableCellStyled>
          <span
            className={clsx(classes.link, { [classes.totalCount]: hasChilds })}
            onClick={() => goTo("items")}
          >
            {get(item, ["device_count"]) + get(item, ["device_total"])}
          </span>
        </TableCellStyled>
        <TableCellStyled>
          <span
            className={clsx(classes.link, { [classes.totalCount]: hasChilds })}
            onClick={() => goTo("profiles")}
          >
            {get(item, ["profile_count"]) + get(item, ["profile_total"]) || 0}
          </span>
        </TableCellStyled>
        {map(zonesData, (data, i) => (
          <TableCellStyled key={i} className={clsx(classes.dataCell)}>
            {i === 1 ? (
              <ZoneColor color={data} />
            ) : i === 4 ? (
              <EllipsedTextNew text={data} maxWidth={250} maxHeight={34} />
            ) : (
              data
            )}
          </TableCellStyled>
        ))}
        {powerUserMode && (
          <>
            <TableCellStyled className={clsx(classes.dataCell)}>
              {displayBoolean(get(item, ["is_impact_site_count"]) || false)}
            </TableCellStyled>
            <TableCellStyled className={clsx(classes.dataCell)}>
              {displayBoolean(get(item, ["is_vehicle_access"]) || false)}
            </TableCellStyled>
            <TableCellStyled className={clsx(classes.dataCell)}>
              {displayBoolean(get(item, ["is_human_access"]) || false)}
            </TableCellStyled>
          </>
        )}
      </>
    );
  };

  const renderDeviceRow = () => {
    return (
      <>
        {size(get(item, ["devices"])) > 0 ? (
          renderExpandableCell(get(item, ["name"]))
        ) : (
          <TableCellStyled
            className={clsx({
              [classes.indented]: level === levels.externalDevice,
              [classes.bottomBorder]: borderBottomCondition,
            })}
          >
            <span className={classes.textLink} onClick={() => goTo("details")}>
              {get(item, ["name"])}
            </span>
          </TableCellStyled>
        )}
        <TableCellStyled
          className={clsx(classes.dataCell, {
            [classes.bottomBorder]: borderBottomCondition,
          })}
        >
          {get(item, [`name_${language}`])}
        </TableCellStyled>
      </>
    );
  };

  return (
    <>
      <TableRow
        style={{
          cursor: "pointer",
          backgroundColor:
            index % 2 === 0 || (levelId === 0 && !props.zoneDetailed)
              ? colors.white
              : colors.tableDarkBg,
        }}
        hover={true}
        classes={{ hover: classes.tableRowHover }}
        onClick={expandRow}
      >
        {level === levels.company
          ? renderCompanyRow()
          : level === levels.site
            ? renderSiteRow()
            : props.zoneDetailed
              ? // (level === levels.zone && levelId === 0) ||
              //   (level === levels.childZone && (levelId === 1 || levelId === 0))
              renderZoneRowDetailed()
              : [levels.zone, levels.childZone].includes(level)
                ? renderZoneRow()
                : [levels.device, levels.externalDevice].includes(level)
                  ? renderDeviceRow()
                  : ""}
      </TableRow>
      {expanded &&
        map(
          level === levels.company
            ? get(item, ["sites"])
            : level === levels.site
              ? get(item, ["zones"])
              : level === levels.zone || level === levels.childZone
                ? get(item, ["childs"])
                : level === levels.device
                  ? get(item, ["external_devices"])
                  : [],
          (subItem, i) => (
            <CompaniesTableRow
              key={get(subItem, ["id"])}
              index={sum([index, i, 1])}
              item={subItem}
              fetchSites={fetchSites}
              fetchZones={fetchZones}
              fetchDevices={fetchDevices}
              level={
                level === levels.company
                  ? levels.site
                  : level === levels.site
                    ? levels.zone
                    : level === levels.zone
                      ? levels.childZone
                      : level === levels.childZone
                        ? levels.childZone
                        : levels.device
              }
              levelId={sum([levelId, 1])}
              zoneLevel={
                level === levels.childZone ? sum([props.zoneLevel, 1]) : 0
              }
              expandedRoot={levelId === 0 ? expanded : expandedRoot}
              expandedParent={expanded}
              hide={props.hide}
              language={language}
              history={props.history}
              zoneDetailed={props.zoneDetailed}
              expandedCompanies={expandedCompanies}
              expandedSites={expandedSites}
              expandedZones={expandedZones}
              onExpand={onExpand}
              isLast={
                (props.isLast || levelId === 0) &&
                i ===
                size(
                  get(item, [
                    level === levels.company
                      ? "sites"
                      : level === levels.site
                        ? "zones"
                        : level === levels.zone
                          ? "childs"
                          : "external_devices",
                  ])
                ) -
                1
              }
              isGroupLast={
                i ===
                size(
                  get(item, [
                    level === levels.company
                      ? "sites"
                      : level === levels.site
                        ? "zones"
                        : level === levels.zone
                          ? "childs"
                          : "external_devices",
                  ])
                ) -
                1
              }
              powerUserMode={powerUserMode}
            />
          )
        )}
    </>
  );
});

export default withRouter(CompaniesTableRow);
